// extracted by css-extract-rspack-plugin
export default {"container":"container__Vu3cZ","button":"button__kffcT"};